import { useState, ChangeEvent, FormEvent, useEffect, useCallback} from 'react'

import Select from 'react-select'
import axios from 'axios'
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component';
import { API_IMAGES, API_URL, config } from '../components/Include';
import { usePaginated, DOTS } from '../components/usePagination';
import { Alerts, CustomLoader, ErrorModal, LoadingModal, SuccessModal, closeModal } from '../components/notify';


const Documents =()=> {

  const [loading, setLoading] = useState(false);
  const [filterContent, setFilterContent] = useState([] as any);
  const [content, setContent] = useState([] as any);
let initial ={
  filterText:'',
  title:'',
  file_path:'',
}

  const [items, setItems] = useState(initial);
  const [update, setUpdate] = useState({
    code:'',
    title:'',
  file_path:'',
});
  const [errors, setErrors] = useState({
    title:'',
  file_path:'',
    successMessage:'',
    errorMessage:''
  });



const handleReset =()=>{
  setItems(initial)
}




       const handleChange =(event:ChangeEvent<HTMLInputElement>)=>{
        let {name, value} = event.target;	

        setItems({...items, [name]:value});
       setErrors({...errors, [name]:''});
     }


     const handleClear =()=>{
      setItems({...items, filterText:''});
      setFilterContent(content)
  }

   const handleSearch =(event:ChangeEvent<HTMLInputElement>)=>{
      let {name, value} = event.target;	
      setItems({...items, [name]:value});

      if(value!==''){
          const filteredItems = content.filter(
              (item:any) => item.title.toLowerCase().includes(value.toLowerCase()) || 
              item.status.toLowerCase().includes(value.toLowerCase()) 
          );

          setFilterContent(filteredItems)
      }else{
          setFilterContent(content)
      } 

   }


     const handleSubmit =(event: FormEvent<HTMLButtonElement>)=>{
      event.preventDefault();
  
      let error = {...errors}; 
      let formIsValid = true;
  
  let msg ='This field is required';
  

  if(!items.title){
    error.title =msg;
    formIsValid = false;
}

if(!items.file_path){
  error.file_path =msg;
  formIsValid = false;
}
  if(!formIsValid){
  setErrors(error) 
  }
  
  
  if(formIsValid) {
  
    let click = document.getElementById('close')?.click();
      LoadingModal()
   const fd = new FormData();
  
          fd.append('title', items.title);
          if(items.file_path){
            fd.append('file_path', items.file_path)
          }

     let url = API_URL+'/document/create';
    axios.post(url, fd, config)
    .then(response =>{
      if(response.data.status === 200){

setErrors({...errors, successMessage:response.data.message})
    
  handleReset()

                } else{

setErrors({...errors, errorMessage:response.data.message})
                }   
            })
            .catch((error)=>{
             ErrorModal('oops', error.message)
            }).finally(()=>{
              closeModal()
              fetchContent()
            }) 
      }
  }

  const copyToClipboard =(link:string)=>{
         
    const el = document.createElement('textarea');
    el.value = link
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    SuccessModal('Link successfully copied')
}


const fetchContent = async()=>{
  setLoading(true)
  let url = API_URL+'/document/display/all'
    await  axios.get(url,  config).then((result:any)=>{
      if(Array.isArray(result.data.data)){
      setContent(result.data.data)
      setFilterContent(result.data.data)
      }
      })
      .catch((error)=>{
       //ErrorModal('oops', error.message)
      }).finally(()=>{
        setLoading(false)
      })
    }

   

 

  const DeleteModal =(code:string)=>{

    let url = API_URL+'/document/delete/'+code;
  
    Swal.fire({
      title: 'Are you really sure?',
      text: "This is very dangerous, you shouldn't do it!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      showLoaderOnConfirm: true,
    preConfirm: async() => {
      return await axios.get(url, config).then(response=>{
       if(response.data.status!==200){
            throw new Error(response.statusText)
          }
          return response.data
        })
        .catch(error => {
          Swal.showValidationMessage(
            `Request failed: ${error}`
          )
        })
    },
    allowOutsideClick: () => !Swal.isLoading(),
      confirmButtonText: 'Yes, I am!'
    }).then((result:any) => {
      if (result.isConfirmed && result.value.status===200) {
       
        let rs =filterContent.filter((item:{code:string})=>item.code !==code)
            setContent(rs)
            setFilterContent(rs)
         Swal.fire(
                    'Deleted!',
                    'Record has been deleted.',
                    'success'
                  ) 
      }
    })
  }


  const  handleFile = function(fieldName:any){
    return function(newValue:any){                 
   readURL(newValue);
   }
  } 
  const readURL = (input:any)=>{
  
    let displayMessage = '';
    
    const PreviewImage = input.target.name;
    const inputElement = document.getElementById(PreviewImage) as HTMLInputElement
    const fileName = inputElement.value
    
    var idxDot = fileName.lastIndexOf(".") + 1;
    var extFile = fileName.substring(idxDot, fileName.length).toLowerCase();
    
    if (extFile==="pdf" || extFile==="PDF" ){
        //TO DO    
        
         var FileSize = input.target.files[0].size / 1024 / 1024; // in MB
    if (FileSize > 3) {
        displayMessage = ' File uploaded is larger than maximum size Allow (3 mb).';
        inputElement.value = '';
     
     setItems({...items, file_path:''})
   
    } else {
        if (input.target.files && input.target.files[0]) { //Check if input has files.
            var reader = new FileReader();//Initialize FileReader.
            reader.onload = function (e:any) {
             
            //Check if input has files.
            setItems({...items, file_path:input.target.files[0]})
            setErrors({...errors, file_path:''})
            }
            reader.readAsDataURL(input.target.files[0]);
        }
    }
    }else{
    displayMessage = 'Only PDF  file format are allowed with maximum of 3 mb'
    inputElement.value = '';
    setItems({...items, file_path:''})
   
    }   
    
    if(displayMessage.length > 0){
      Alerts('danger', displayMessage)
    }
    }
  

    
  const TableData =()=>{

            
    const PaginationWrapper =(props:any)=>{
    
        const handleRowsPerPage = useCallback(
            (e: React.ChangeEvent<HTMLSelectElement>) => props.onChangeRowsPerPage(Number(e.target.value), props.currentPage),
            [props.currentPage, props.onChangeRowsPerPage],
        );
        const handleSelectRowsPerPage = useCallback((option:any, action:any)=> props.onChangeRowsPerPage(Number(option.value), props.currentPage),
        [props.currentPage, props.onChangeRowsPerPage],
        )
       
        function getNumberOfPages(rowCount:number, rowsPerPage:number) {
            return Math.ceil(rowCount / rowsPerPage);
          }
        const numPages = getNumberOfPages(props.rowCount, props.rowsPerPage);
        const lastIndex = props.currentPage * props.rowsPerPage;
        const firstIndex = lastIndex - props.rowsPerPage + 1;
    
    
            const range =
            props.currentPage === numPages ?  `Showing ${firstIndex} to ${props.rowCount} of ${props.rowCount} entries`:
    
            `Showing ${firstIndex} to ${lastIndex} of ${props.rowCount} entries`
    
        
       
        const Pagination = () => {
           
            const pageSize = props.rowsPerPage;
            const totalCount = content.length
            const siblingCount = 1
            const currentPage = props.currentPage
            
            const paginationRange = usePaginated({ currentPage,  totalCount, siblingCount,  pageSize });
            
            if (currentPage === 0 ) {
              return null;
            }
            
            let lastPage =  paginationRange&&paginationRange[paginationRange.length - 1];
            return (
            <nav className="" aria-label="Page navigation sample ">
              <ul  className="pagination pagination-sm"  >
                <li className={currentPage === 1 ? ' page-item disabled' : 'page-item'} >
                 <a className="page-link pointer"  onClick={() =>props.onChangePage(props.currentPage - 1)}>Prev</a>
                </li>
                {paginationRange&&paginationRange.map((pageNumber, index) => {
                  if (pageNumber === DOTS) {
                    return <li className="pagination-item dots" key={index}>
                     <a className="page-link pointer"  >&#8230;</a>
                    </li>
                  }
                  return (
                    <li className={pageNumber === currentPage?' page-item  active':'page-item '} key={index} >
                      <a className="page-link pointer"  onClick={() =>props.onChangePage(pageNumber)} >{pageNumber}</a>
                      
                    </li>
                  );
                })}
            
            <li  className={currentPage === lastPage  ? ' page-item disabled' : 'page-item'}>
            <a className="page-link pointer"  onClick={() =>props.onChangePage(props.currentPage + 1)} aria-label="Next">Next</a>
                </li>
            
              </ul> </nav>
            );
            
                }
    
              
  
              
    
     return <div className="row mt-3">
                        
    <div className="col-md-5 ">
    <div className=" ml-3" >
    
        &nbsp; <select name="rowPerPage" id="" className=' h-40 ' onChange={handleRowsPerPage}>
            <option value="10"> 10</option>
            <option value="20"> 20</option>
            <option value="30"> 30</option>
            <option value="40"> 40</option>
            <option value="50"> 50</option>
            <option value={content.length}> All</option>
        </select> &nbsp;&nbsp;
         {range}  </div>
    </div>
      
    <div className="col-md-7  justify-content-end d-flex">
       <Pagination  />
        </div>
        
    </div>}
    
    
                const columns = [
    
                    {
                        name: 'SN',
                        cell: (row:any, index:number) => index+1, 
               
                        width:'60px'
                    },
                    {
                      name: 'Title',
                      cell: (row:any) =><a href={API_IMAGES+'/documents/'+row.file_path} target='_blank'> {row.title}</a>, 
                      sortable: true,
                      reorder:true,
                      wordwrap:true,
                  },
                    
                    {
                        name: 'Action',
                        cell: (row:any, index:any, column:any, id:any) => <div >  
                           
                           <button onClick={()=>copyToClipboard(API_IMAGES+'/documents/'+row.file_path)} type='button'  className="btn btn-info btn-sm"   ><i className='fa fa-copy'></i> Copy</button>
    &nbsp;
   
                 <button className="btn btn-danger-transparent btn-sm" data-bs-toggle="tooltip" title="" data-bs-original-title="Delete" onClick={()=>DeleteModal(row.code)}><i className='fa fa-trash'></i> Delete</button>
                        
                        </div>,
                            left:true,
                            width:'200px'
                    }
                ];
                
            
                return <>
                
    
                <DataTable
                columns={columns}
                data={filterContent}
                highlightOnHover
                pagination
                paginationComponent={PaginationWrapper}
                selectableRowsHighlight
                striped
                responsive
                fixedHeader
                progressPending={loading}
                progressComponent={<CustomLoader />}
            />
            </>
            }
    
            
    useEffect(()=>{  
     fetchContent()   
    },[]); 
  return (
    <>


    <div className="modal fade" id="addDocument" data-bs-backdrop="static" aria-modal="true"> 
    <div className="modal-dialog modal-lg modal-dialog-centered" role="document"> 
    <div className="modal-content "> 

    <div className="modal-header  bg-gradient-dark">
              <h6 className="modal-title text-white my-auto ps-1">Add New Document</h6>
              <button type="button" id='close' className="close" data-bs-dismiss="modal" aria-label="Close">
              <i className='fa fa-ban text-danger'></i>
              </button>
            </div>


    <div className="modal-body"> 
    
    
    <form action="#" className='needs-validations '> 
    <div className="row"> 

 


    <div className="col-md-12">
       <div className={`form-group  form-floating mg-md-b-0-f ${errors.title?'border-danger':''}`}> 

       <input type="text" name="title" value={items.title} onChange={handleChange} className="form-control" id="title" placeholder="" /> 
       
       <label htmlFor="title" className='fw-bold'>Document Title</label> 
       </div> 
       <div className="text-danger">{errors.title} </div>
       </div> 
       

       <div className="col-md-12">

<div className="mb-3">
  <label htmlFor="file"  className={`form-label fw-bold `}>Upload File <span>PDF only with 2MB max</span></label> 
  <input  type="file" className={`form-control fw-bold ${errors.file_path?'border-danger':''}`} onChange={handleFile('file_path')} accept="application/pdf" name="file_path" id="file_path" /> 

  <div className="text-danger">{errors.file_path} </div>
  </div>

</div>

        </div> 
        </form>


    <div className="modal-footer ">

<button type="button" data-bs-dismiss="modal" className="btn btn-warning bg-gradient-warning" >
      <i className="fa fa-times-circle"></i>
      Close
      </button>
<button type="button" className="btn btn-success" onClick={handleSubmit} > <i className="fa fa-save"></i> Upload </button>

</div>

    </div> 
    </div> 
    </div> 
    
    </div> 


       


              
    <div className="page-header d-sm-flex d-block"> 
               
               <h4 className="page-title">
                <i className="fa fa-file me-1"></i> Upload Documents</h4> 
                <ol className="breadcrumb"> 
                <li className="breadcrumb-item"><a href="/dashboard">Home</a></li> 
                <li className="breadcrumb-item active" aria-current="page">Document</li> </ol> 
                </div> 


                {errors.errorMessage!==''?
				  <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {errors.errorMessage}
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>:''}
          

          {errors.successMessage!==''?
				  <div className="alert alert-success alert-dismissible fade show" role="alert">
          {errors.successMessage}
            <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
          </div>:''}

               <div className="row row-sm">

               <div className="col-xl-12"> 
               <div className="card"> 
               <div className="card-header  d-flex justify-content-between"> 
               <div className="card-title">All Documents</div>

              
          
                </div> 
                <div className="card-body"> 



                <div className="row">

<div className=" col-md-8 ">

  <div className="btn-group mb-3 ">
                   
  <button type='button'  data-bs-target="#addDocument" data-bs-toggle="modal"  className='btn btn-primary'> <i className='fa fa-plus'></i> Add New File</button>


                  </div>
                  </div>

    <div className=" col-md-4 ">

    <div className="input-group mb-3"> 
       
    <input type="text" name="filterText" id="filterText" key="filterText"  onChange={handleSearch} value={items.filterText} className="form-control" placeholder="Type to search" />
       <span onClick={handleClear} className="input-group-text bg-default pointer" id="basic-addon1"><i className="fa fa-close"></i></span>  
       </div>
    </div>
</div>


               <TableData />

               </div> </div> 
               </div>

               </div>



    </>
  )
}

export default Documents